import './_updates.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Grid } from 'react-bootstrap';
import qs from 'qs';

import Loader from '../../components/Loaders/Loader';
import FilterGroup from '../../components/Filters/FilterGroup';
import SearchGroup from '../../components/Search/SearchGroup';
import Pagination from '../../components/Pagination';
import ConfirmModal from '../../components/Modal/Confirm';
import ConfirmTemplates from './components/ConfirmTemplates';
import Table from './components/Table';

import { getRootStateSelector } from '../../redux/selectors/root';
import { updatesSelector } from '../../redux/selectors/updates';
import { getUpdatesListAction, deleteUpdatesAction } from '../../redux/actions/updates';
import { prepareConfirmBtnsText } from './helpers';

const Updates = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const queryString = qs.parse(location.search.slice(1));

  const { updates, pagination, access, types } = useSelector((state) => getRootStateSelector(state));
  const { isFetching } = useSelector((state) => updatesSelector(state));

  const [values, setValues] = useState([]);
  const [confirmValues, setConfirmValues] = useState({
    key: null,
    title: '',
  });
  const [loading, setLoading] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const toggleConfirm = () => setIsOpenConfirm(!isOpenConfirm);

  const onSubmitConfirm = () => {
    const { id, title } = confirmValues;

    switch (title) {
    case 'single':
      dispatch(deleteUpdatesAction([id]));
      break;

    case 'mass':
      dispatch(deleteUpdatesAction(values));
      break;

    default:
      break;
    }

    setValues([]);
    setIsOpenConfirm(false);
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getUpdatesListAction(queryString))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));

    document.title = 'Updates';
    setValues([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location]);

  return (
    <Grid fluid>
      <ConfirmModal
        toggle={toggleConfirm}
        isOpen={isOpenConfirm}
        onConfirm={onSubmitConfirm}
        title={<ConfirmTemplates.Title actionKey={confirmValues.key} {...confirmValues} />}
        description={<ConfirmTemplates.Body selectedCount={values.length} actionKey={confirmValues.key} {...confirmValues} />}
        {...prepareConfirmBtnsText()}
      />

      <FilterGroup>
        <SearchGroup autocomplete="on" sectionName="updates" placeholder="Search" />
      </FilterGroup>

      {loading || isFetching ? (
        <Loader />
      ) : (
        <>
          <Table
            items={updates}
            access={access}
            filters={types}
            setConfirmValues={setConfirmValues}
            toggleConfirm={toggleConfirm}
            values={values}
            setValues={setValues}
          />
          <Pagination
            pages={pagination?.pages}
            currentPage={pagination?.current_page}
            itemsCount={pagination?.total_count}
            pageSize={pagination?.page_size}
            pagesLimit={pagination?.pages < 10 ? pagination?.pages : 10}
          />
        </>
      )}
    </Grid>
  );
};

export default Updates;
